import Box from '@mui/material/Box';
import React from 'react';
import {alpha} from '@mui/material/styles';

import Timeline from './timeline.jsx';

const Container = props => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      px: 1.5,
      background: theme =>
        `linear-gradient(${alpha(theme.palette.grey[900], 0)}, ${alpha(
          theme.palette.grey[900],
          0.95
        )})`,
    }}
    {...props}
  />
);

const TimelineContainer = () => {
  return (
    <Container>
      <Timeline />
    </Container>
  );
};

export default TimelineContainer;
